import { useEffect, useState } from 'react';
/** Reactive media-query hook. Drives the laptop/mobile shell switch (D-062 parity). */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
    useEffect(() => {
        const mq = window.matchMedia(query);
        const handler = () => setMatches(mq.matches);
        handler();
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
}
//# sourceMappingURL=useMediaQuery.js.map